import './main.scss';
import React, {useState} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import decodeToken from '../../../../utils/decode-token';
import {useTranslation} from 'react-i18next';

import Footer from "../../../organisms/footer/footer";

import ExperienceCatalog from "../../../organisms/common/experiences/catalog";


const PmaExperienceCatalog = () => {
  window.scroll(0, 0);

  const {t} = useTranslation();

  const token = sessionStorage.getItem('token') || null;
  const role = decodeToken(token).role;
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('experiences');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 'hac') {
      navigate('/pma/main/hac');
    } else if (tab === 'pma') {
      navigate('/pma/main/pma');
    } else if (tab === 'experiences') {
      navigate('/pma/catalog');
    }
  };

  return (
    <>
      {token && (role === 'pma' || role === 'pmaGM') ? (
        <div className="App">
          <Header/>
          <main className="landing">
            <div className="tabs">
              <ul>
                <li className={activeTab === 'hac' ? 'active' : ''}>
                    <span onClick={() => handleTabClick('hac')}>
                      {t('admin-main-tabs-tab1')}
                    </span>
                </li>
                {role === 'pmaGM' && (
                  <li className={activeTab === 'pma' ? 'active' : ''}>
                      <span onClick={() => handleTabClick('pma')}>
                        {t('admin-main-tabs-tab2')}
                      </span>
                  </li>
                )}
                <li className={`opossed ${activeTab === 'experiences' ? 'active' : ''}`}>
                  <span onClick={() => handleTabClick('experiences')}>{t('common-experiences')}</span>
                </li>
              </ul>
            </div>
            <section className="gallery catalog">
              <div className="inner">
                <ExperienceCatalog></ExperienceCatalog>
              </div>
            </section>
          </main>
          <Footer/>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}

    </>
  );
};

export default PmaExperienceCatalog;
